import React, { Component } from 'react';
import { Card, message } from 'antd';

import {
  queryIncuOregistappMoveOutWorkflow,
  querySaveIncuOregistappMoveOut,
} from '@api/incubator/oregistappMoveOut';
import { queryIncuOregistappInfo } from '@api/incubator/oregistapp';

import Process from '@comm/workflow/Process';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getIncuOregistappMoveOutWorkflow();
    this.getIncuOregistappInfo();
  }

  /**
   * 提交迁出
   */
  handSubmit = item => {
    delete item.apportionType;
    this.saveIncuOregistappMoveOut(item);
  };

  getIncuOregistappMoveOutWorkflow = params => {
    const { instance } = this.state;
    queryIncuOregistappMoveOutWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  getIncuOregistappInfo = () => {
    queryIncuOregistappInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 保存
   */
  saveIncuOregistappMoveOut = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveIncuOregistappMoveOut(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.push(`/incubator/oregistappMoveOut_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo, isSubmitting, instance } = this.state;
    return (
      <div>
        <FormBase data={dataInfo} handSubmit={this.handSubmit} isSubmitting={isSubmitting} />
        <Card>
          <Process instance={instance} />
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/PageAdd.js